var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37101 10.5065L0.581055 20.1721C0.58188 20.1738 0.58188 20.1764 0.582706 20.1781C0.852671 21.2276 1.77732 22 2.87534 22C3.31455 22 3.72652 21.8768 4.07987 21.6613L4.10794 21.6442L14.0017 15.7294L9.37101 10.5065Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.263 8.86084L18.2548 8.85485L13.9832 6.28963L9.1709 10.7264L14.0005 15.7285L18.249 13.189C18.9937 12.7715 19.4997 11.9581 19.4997 11.0206C19.4997 10.0883 19.0011 9.27911 18.263 8.86084Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.580907 1.82698C0.52807 2.02885 0.5 2.24098 0.5 2.45995V19.5398C0.5 19.7587 0.52807 19.9709 0.581732 20.1719L9.67303 10.7535L0.580907 1.82698Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43623 11L13.9852 6.28783L4.10298 0.351632C3.74385 0.128384 3.32446 8.01086e-05 2.87617 8.01086e-05C1.77815 8.01086e-05 0.851845 0.774179 0.58188 1.82456C0.58188 1.82542 0.581055 1.82627 0.581055 1.82713L9.43623 11Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.a3e157375f67e7c7a3c0f38f3bddf6d9.svg";
export { ForwardRef as ReactComponent };